// extracted by mini-css-extract-plugin
export default {"container":"collection-image_container__1cYxX","brandIcon":"collection-image_brandIcon__1-URY","empty":"collection-image_empty__2R0L-"};